export default "__VITE_ASSET__db5cacb5__"